import React from 'react';

export function Spinner(props) {
  return (
    <div className="spinner-container text-center">
      <div className={`lds-dual-ring ${props.className}`} />
    </div>
  );
}

export function DisabledWithSpinner(props) {
  return (
    <div className="loading-disabled">
      <div className="spinner-container text-center">
        <div className={`lds-dual-ring ${props.className}`} />
      </div>
    </div>
  );
}

export default Spinner;
